import ReactGA from 'react-ga4';

const TRACKING_ID = "G-V9ZY4EGL7Z";

// Inicializar GA con opción para no enviar pageview automático
export const initializeGA = () => {
  ReactGA.initialize(TRACKING_ID, {
    send_page_view: false,  // Crucial: desactiva el pageview automático
    debug_mode: true        // Activa el modo debug temporalmente
  });
  console.log("GA initialized with tracking ID:", TRACKING_ID);
};

// Función mejorada para rastrear vistas de página
export const trackPageView = (path) => {
  // Asegúrate de que la ruta comience con /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  
  console.log("🔍 Tracking pageview for path:", normalizedPath);
  
  // Envía el evento pageview con datos adicionales para asegurar que se registre correctamente
  ReactGA.send({
    hitType: "pageview",
    page: normalizedPath,
    title: document.title,  // Incluye el título de la página
    location: window.location.origin + normalizedPath  // URL completa
  });
};

export const trackEvent = (category, action, label) => {
  console.log(`📊 Tracking event - Category: ${category}, Action: ${action}, Label: ${label}`);
  ReactGA.event({
    category,
    action,
    label
  });
};